import posthog from "posthog-js";

const POSTHOG_ENABLED = import.meta.env.VITE_POSTHOG_ENABLED === "true";
const POSTHOG_KEY =
  import.meta.env.VITE_POSTHOG_KEY ||
  "phc_C6pTYaCcyCXPxSJMFqmhC8A3anfPULjocwmkkGsQyCLP";
const POSTHOG_API_HOST =
  import.meta.env.VITE_POSTHOG_HOST || "https://e.spectra-payment.com";
const POSTHOG_UI_HOST =
  import.meta.env.VITE_POSTHOG_UI_HOST || "https://eu.posthog.com";

let started = false;

export function initPostHog() {
  if (!POSTHOG_ENABLED || typeof window === "undefined") return posthog;
  if (started || posthog.__loaded) {
    started = true;
    return posthog;
  }
  if (!POSTHOG_KEY) return posthog;

  started = true;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_API_HOST,
    ui_host: POSTHOG_UI_HOST,
    defaults: "2025-05-24",
    autocapture: true,
    capture_pageview: "history_change",
    capture_pageleave: true,
    capture_dead_clicks: true,
    enable_heatmaps: true,
    capture_exceptions: true,
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: false,
      recordHeaders: false,
      recordBody: false,
    },
    capture_performance: {
      network_timing: true,
    },
  });

  return posthog;
}

export { posthog };
